import React from "react";
import BlogHero from "../components/blog/BlogHero";
import BlogGrid from "../components/blog/BlogGrid";
import BlogNewsletter from "../components/blog/BlogNewsletter";
import SEO from "../components/SEO";
import { useApp } from "../context/AppContext";

const Blog = () => {
  const { companyinfo } = useApp();
  return (
    <>
      <SEO
        title="Our Blogs | Research Insights"
        description="Read research-driven insights, field perspectives, and expert analysis regarding MEL updates and development frameworks from the Agora Consulting team."
        keywords={[
          "MEL insights",
          "Formative research updates",
          "Development methodology",
          "Research digest Ethiopia",
        ]}
        url="https://agoraconsulting-et.com/blog"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-gray-50">
        <BlogHero />
        <BlogGrid />
        <BlogNewsletter />
      </main>
    </>
  );
};

export default Blog;
